const ALIGNMENT_POSITIONS = ['left', 'right', 'center', 'justify'];

export default ALIGNMENT_POSITIONS;
